import { collectionSizeOrDefault36dulx8yinfqm as collectionSizeOrDefault } from '../../../../kotlin-kotlin-stdlib/kotlin/collections/Iterables.mjs';
import { mapCapacity1h45rc3eh9p2l as mapCapacity } from '../../../../kotlin-kotlin-stdlib/kotlin/collections/collectionJs.mjs';
import { coerceAtLeast2bkz8m9ik7hep as coerceAtLeast } from '../../../../kotlin-kotlin-stdlib/kotlin/ranges/_Ranges.mjs';
import { LinkedHashMap1zhqxkxv3xnkl as LinkedHashMap } from '../../../../kotlin-kotlin-stdlib/kotlin/collections/LinkedHashMap.mjs';
import { Unit_instance3vdlo4e4f5ggx as Unit_instance } from '../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import {
  initMetadataForCompanion1wyw17z38v6ac as initMetadataForCompanion,
  initMetadataForClassbxx6q50dy2s7 as initMetadataForClass,
} from '../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import { THROW_CCE2g6jy02ryeudk as THROW_CCE } from '../../../../kotlin-kotlin-stdlib/kotlin/hacks.mjs';
import { Comparable198qfk8pnblz0 as Comparable } from '../../../../kotlin-kotlin-stdlib/kotlin/Comparable.mjs';
import { listOf1jh22dvmctj1r as listOf } from '../../../../kotlin-kotlin-stdlib/kotlin/collections/CollectionsKt.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
var CompanionClass;
function Companion() {
  if (CompanionClass === VOID) {
    class $ {
      constructor() {
        Companion_instance = this;
        this.r52_1 = new (HttpStatusCode())(100, 'Continue');
        this.s52_1 = new (HttpStatusCode())(101, 'Switching Protocols');
        this.t52_1 = new (HttpStatusCode())(102, 'Processing');
        this.u52_1 = new (HttpStatusCode())(200, 'OK');
        this.v52_1 = new (HttpStatusCode())(201, 'Created');
        this.w52_1 = new (HttpStatusCode())(202, 'Accepted');
        this.x52_1 = new (HttpStatusCode())(203, 'Non-Authoritative Information');
        this.y52_1 = new (HttpStatusCode())(204, 'No Content');
        this.z52_1 = new (HttpStatusCode())(205, 'Reset Content');
        this.a53_1 = new (HttpStatusCode())(206, 'Partial Content');
        this.b53_1 = new (HttpStatusCode())(207, 'Multi-Status');
        this.c53_1 = new (HttpStatusCode())(300, 'Multiple Choices');
        this.d53_1 = new (HttpStatusCode())(301, 'Moved Permanently');
        this.e53_1 = new (HttpStatusCode())(302, 'Found');
        this.f53_1 = new (HttpStatusCode())(303, 'See Other');
        this.g53_1 = new (HttpStatusCode())(304, 'Not Modified');
        this.h53_1 = new (HttpStatusCode())(305, 'Use Proxy');
        this.i53_1 = new (HttpStatusCode())(306, 'Switch Proxy');
        this.j53_1 = new (HttpStatusCode())(307, 'Temporary Redirect');
        this.k53_1 = new (HttpStatusCode())(308, 'Permanent Redirect');
        this.l53_1 = new (HttpStatusCode())(400, 'Bad Request');
        this.m53_1 = new (HttpStatusCode())(401, 'Unauthorized');
        this.n53_1 = new (HttpStatusCode())(402, 'Payment Required');
        this.o53_1 = new (HttpStatusCode())(403, 'Forbidden');
        this.p53_1 = new (HttpStatusCode())(404, 'Not Found');
        this.q53_1 = new (HttpStatusCode())(405, 'Method Not Allowed');
        this.r53_1 = new (HttpStatusCode())(406, 'Not Acceptable');
        this.s53_1 = new (HttpStatusCode())(407, 'Proxy Authentication Required');
        this.t53_1 = new (HttpStatusCode())(408, 'Request Timeout');
        this.u53_1 = new (HttpStatusCode())(409, 'Conflict');
        this.v53_1 = new (HttpStatusCode())(410, 'Gone');
        this.w53_1 = new (HttpStatusCode())(411, 'Length Required');
        this.x53_1 = new (HttpStatusCode())(412, 'Precondition Failed');
        this.y53_1 = new (HttpStatusCode())(413, 'Payload Too Large');
        this.z53_1 = new (HttpStatusCode())(414, 'Request-URI Too Long');
        this.a54_1 = new (HttpStatusCode())(415, 'Unsupported Media Type');
        this.b54_1 = new (HttpStatusCode())(416, 'Requested Range Not Satisfiable');
        this.c54_1 = new (HttpStatusCode())(417, 'Expectation Failed');
        this.d54_1 = new (HttpStatusCode())(422, 'Unprocessable Entity');
        this.e54_1 = new (HttpStatusCode())(423, 'Locked');
        this.f54_1 = new (HttpStatusCode())(424, 'Failed Dependency');
        this.g54_1 = new (HttpStatusCode())(425, 'Too Early');
        this.h54_1 = new (HttpStatusCode())(426, 'Upgrade Required');
        this.i54_1 = new (HttpStatusCode())(429, 'Too Many Requests');
        this.j54_1 = new (HttpStatusCode())(431, 'Request Header Fields Too Large');
        this.k54_1 = new (HttpStatusCode())(500, 'Internal Server Error');
        this.l54_1 = new (HttpStatusCode())(501, 'Not Implemented');
        this.m54_1 = new (HttpStatusCode())(502, 'Bad Gateway');
        this.n54_1 = new (HttpStatusCode())(503, 'Service Unavailable');
        this.o54_1 = new (HttpStatusCode())(504, 'Gateway Timeout');
        this.p54_1 = new (HttpStatusCode())(505, 'HTTP Version Not Supported');
        this.q54_1 = new (HttpStatusCode())(506, 'Variant Also Negotiates');
        this.r54_1 = new (HttpStatusCode())(507, 'Insufficient Storage');
        this.s54_1 = allStatusCodes();
        var tmp = this;
        // Inline function 'kotlin.collections.associateBy' call
        var this_0 = this.s54_1;
        var capacity = coerceAtLeast(mapCapacity(collectionSizeOrDefault(this_0, 10)), 16);
        // Inline function 'kotlin.collections.associateByTo' call
        var destination = LinkedHashMap().fc(capacity);
        var _iterator__ex2g4s = this_0.p1();
        while (_iterator__ex2g4s.q1()) {
          var element = _iterator__ex2g4s.r1();
          var tmp$ret$2 = element.u54_1;
          destination.x4(tmp$ret$2, element);
        }
        tmp.t54_1 = destination;
      }
    }
    initMetadataForCompanion($);
    CompanionClass = $;
  }
  return CompanionClass;
}
var Companion_instance;
function Companion_getInstance() {
  if (Companion_instance === VOID)
    new (Companion())();
  return Companion_instance;
}
var HttpStatusCodeClass;
function HttpStatusCode() {
  if (HttpStatusCodeClass === VOID) {
    class $ {
      constructor(value, description) {
        Companion_getInstance();
        this.u54_1 = value;
        this.v54_1 = description;
      }
      toString() {
        return '' + this.u54_1 + ' ' + this.v54_1;
      }
      equals(other) {
        var tmp;
        if (other instanceof HttpStatusCode()) {
          tmp = other.u54_1 === this.u54_1;
        } else {
          tmp = false;
        }
        return tmp;
      }
      hashCode() {
        return this.u54_1;
      }
      w54(other) {
        return this.u54_1 - other.u54_1 | 0;
      }
      d(other) {
        return this.w54(other instanceof HttpStatusCode() ? other : THROW_CCE());
      }
    }
    initMetadataForClass($, 'HttpStatusCode', VOID, VOID, [Comparable()]);
    HttpStatusCodeClass = $;
  }
  return HttpStatusCodeClass;
}
function allStatusCodes() {
  return listOf([Companion_getInstance().r52_1, Companion_getInstance().s52_1, Companion_getInstance().t52_1, Companion_getInstance().u52_1, Companion_getInstance().v52_1, Companion_getInstance().w52_1, Companion_getInstance().x52_1, Companion_getInstance().y52_1, Companion_getInstance().z52_1, Companion_getInstance().a53_1, Companion_getInstance().b53_1, Companion_getInstance().c53_1, Companion_getInstance().d53_1, Companion_getInstance().e53_1, Companion_getInstance().f53_1, Companion_getInstance().g53_1, Companion_getInstance().h53_1, Companion_getInstance().i53_1, Companion_getInstance().j53_1, Companion_getInstance().k53_1, Companion_getInstance().l53_1, Companion_getInstance().m53_1, Companion_getInstance().n53_1, Companion_getInstance().o53_1, Companion_getInstance().p53_1, Companion_getInstance().q53_1, Companion_getInstance().r53_1, Companion_getInstance().s53_1, Companion_getInstance().t53_1, Companion_getInstance().u53_1, Companion_getInstance().v53_1, Companion_getInstance().w53_1, Companion_getInstance().x53_1, Companion_getInstance().y53_1, Companion_getInstance().z53_1, Companion_getInstance().a54_1, Companion_getInstance().b54_1, Companion_getInstance().c54_1, Companion_getInstance().d54_1, Companion_getInstance().e54_1, Companion_getInstance().f54_1, Companion_getInstance().g54_1, Companion_getInstance().h54_1, Companion_getInstance().i54_1, Companion_getInstance().j54_1, Companion_getInstance().k54_1, Companion_getInstance().l54_1, Companion_getInstance().m54_1, Companion_getInstance().n54_1, Companion_getInstance().o54_1, Companion_getInstance().p54_1, Companion_getInstance().q54_1, Companion_getInstance().r54_1]);
}
//region block: exports
export {
  Companion_getInstance as Companion_getInstance2192nrpo98q6y,
  HttpStatusCode as HttpStatusCode3o1wkms10pg4k,
};
//endregion

//# sourceMappingURL=HttpStatusCode.mjs.map
